<template>
  <!-- 社内メニュー(splitterあり)とメインコンテンツ(splitterなし)を切り替えるnavigator -->
  <div @click="click">
    <v-ons-navigator
      :page-stack="pageStack"
      :options="options"
    />

    <load-progress />
  </div>
</template>

<script>
import loadProgress from '@/components/partials/loading.vue';
import homeSplitter from './home/splitter.vue';

export default {
  components: { loadProgress },
  computed: {
    pageStack: ({ $store }) => $store.state.appNavigator.stack,
    options: ({ $store }) => $store.state.appNavigator.options,
    noOperationTimer: ({ $store }) => $store.state.appNavigator.noOperationTimer,
    goToRedirectHomeOption: ({ $store }) => $store.state.appNavigator.goToRedirectHomeOption,
  },
  beforeCreate() {
    this.$store.commit('appNavigator/push', homeSplitter);
  },
  mounted() {
    // NOTE: 一定時間無操作でリダイレクト用homeに遷移するタイマーを動かす
    this.$store.dispatch('appNavigator/startNoOperationTimer', this.goToRedirectHomeOption);
  },
  methods: {
    click() {
      this.$store.dispatch('appNavigator/updateNoOperationTimer', this.goToRedirectHomeOption);
    },
  },
};
</script>



// WEBPACK FOOTER //
// app_navigator.vue?95c42480